/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

/*
    Announcement bar
*/
document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest('.announcement-bar .carousel')

    if (carousel) {
        bootstrap.Carousel.getOrCreateInstance(carousel, { ride: false })
            .to(event.target.dataset.index)
    }
})

/*
    Carousel
*/
document.addEventListener('shopify:block:select', (event) => {
    const carousel = event.target.closest('.carousel')

    if (carousel) {
        bootstrap.Carousel.getOrCreateInstance(carousel, { ride: false })
            .to(event.target.dataset.index)
    }
})

/*
    Marquee
*/
const initMarqueeSections = () => {
    document.querySelectorAll('.marquee').forEach(section => {
        const list = section.querySelector('ul')
        const marqueeWidth = list.scrollWidth
        const marqueeLength = list.querySelectorAll('li').length

        list.insertAdjacentHTML('beforeEnd', list.innerHTML)
        list.insertAdjacentHTML('beforeEnd', list.innerHTML)

        list.querySelectorAll('li').forEach((item, index) => {
            if (index >= marqueeLength) {
                item.setAttribute('aria-hidden', 'true')
            }
        })

        let style = `
            <style>
                #marquee-${list.dataset.sectionId} ul {
                    animation-name: marquee-animation-${list.dataset.sectionId};
                    animation-duration: ${list.dataset.animationDuration}s;
                }
                @keyframes marquee-animation-${list.dataset.sectionId} {
                    to { transform: translateX(-${marqueeWidth}px); }
                }
            </style>
        `
        if (list.dataset.marqueeDirection === 'right') {
            style += `
                <style>
                    @keyframes marquee-animation-${list.dataset.sectionId} {
                        from { transform: translateX(-${marqueeWidth}px); }    
                        to { transform: 0); }    
                    }
                </style>
            `
        }

        list.insertAdjacentHTML('beforeBegin', style)
    })
}
initMarqueeSections()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.marquee')) {
        initMarqueeSections()
    }
})

/*
    Featured Products
*/
const initFeaturedProducts = () => {
    document.querySelectorAll('.featured-products:not(.init)').forEach(section => {
        section.classList.add('init')

        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            arrows: element.dataset.arrows === 'true',
            pagination: element.dataset.pagination === 'true',
            easing: element.dataset.easing,
            speed: Number(element.dataset.speed),
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: 0 },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            }
        })

        const fixArrowsPos = () => {
            const top = section.querySelector('.product-item-img')?.clientHeight / 2
            section.querySelectorAll('.splide__arrow').forEach(arrow => {
                arrow.style.top = `${top}px`
            })
        }

        const fixPagination = () => {
            if (window.matchMedia('(max-width: 575px').matches) {
                const pagination = section.querySelector('.splide__pagination')

                if (!pagination) return

                section.querySelector('.splide__pagination--mobile')?.remove()

                const total = pagination.querySelectorAll('button').length

                let text = element.dataset.textSlideOf.replace('[x]', mySplide.index + 1)
                text = text.replace('[total]', total)

                pagination.insertAdjacentHTML('beforebegin', `
                    <div class="splide__pagination--mobile text-muted small">
                        ${text}
                    </div>
                `)
            }
        }

        mySplide.on('ready resize', () => {
            fixArrowsPos()
            fixPagination()
        })

        mySplide.on('move', () => {
            fixPagination()
        })

        mySplide.mount()
    })
}
initFeaturedProducts()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.featured-products')) {
        initFeaturedProducts()
    }
})

/*
    Recommended Products
    https://shopify.dev/themes/product-merchandising/recommendations
*/
const initRecommendedProducts = async () => {
    const section = document.querySelector('.recommended-products')

    if (!section) return

    const { sectionId, baseUrl, productId, limit } = section.dataset

    // Sprint 3 / C6: primero "complementary" (Search & Discovery), si trae menos de 2 → "related".
    const fetchRecs = async (intent) => {
        const url = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`
        const response = await fetch(url)
        const html = await response.text()
        const doc = new DOMParser().parseFromString(html, 'text/html')
        // nunca mostrar el producto actual
        doc.querySelectorAll(`.product-item[data-product-id="${productId}"]`).forEach(el => el.remove())
        return { html: doc.body.innerHTML, count: doc.querySelectorAll('.product-item').length }
    }

    let recs = await fetchRecs('complementary')
    if (recs.count < 2) {
        recs = await fetchRecs('related')
    }

    if (recs.count === 0) {
        section.closest('.shopify-section').remove()
        return
    }

    section.closest('.shopify-section').outerHTML = recs.html

    document.querySelectorAll('.recommended-products [data-bs-toggle="popover"]')
        .forEach((el) => bootstrap.Popover.getOrCreateInstance(el))

    initFeaturedProducts()

    const customEvent = new CustomEvent('init.ecomify.recommended_products')
    window.dispatchEvent(customEvent)
}
initRecommendedProducts()

// Listen for changes in the Shopify Theme Editor
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.recommended-products')) {
        initRecommendedProducts()
    }
})

/*
    Testimonials
*/
const initTestimonials = () => {
    document.querySelectorAll('.testimonials').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            arrows: element.dataset.arrows === 'true',
            pagination: element.dataset.pagination === 'true',
            easing: element.dataset.easing,
            speed: Number(element.dataset.speed),
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: '10%' },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            }
        })

        const fixArrowsPos = () => {
            const top = section.querySelector('.card').clientHeight / 2
            section.querySelectorAll('.splide__arrow').forEach(arrow => {
                arrow.style.top = `${top}px`
            })
        }

        const fixPagination = () => {
            if (window.matchMedia('(max-width: 575px').matches) {
                const pagination = section.querySelector('.splide__pagination')

                if (!pagination) return

                section.querySelector('.splide__pagination--mobile')?.remove()

                const total = pagination.querySelectorAll('button').length

                let text = element.dataset.textSlideOf.replace('[x]', mySplide.index + 1)
                text = text.replace('[total]', total)

                pagination.insertAdjacentHTML('beforebegin', `
                    <div class="splide__pagination--mobile text-muted small">
                        ${text}
                    </div>
                `)
            }
        }

        mySplide.on('ready resize', () => {
            fixArrowsPos()
            fixPagination()
        })

        mySplide.on('move', () => {
            fixPagination()
        })

        mySplide.mount()
    })
}
initTestimonials()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.testimonials')) {
        initTestimonials()
    }
})

/*
    Instagram Gallery
*/
const initInstagramGallery = () => {
    document.querySelectorAll('.instagram-gallery').forEach(section => {
        const element = section.querySelector('.splide')

        let speed = Number(element.dataset.speed)

        if (element.dataset.direction === 'right') {
            speed = -Math.abs(speed)
        }

        const mySplide = new Splide(element, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            arrows: element.dataset.arrows === 'true',
            pagination: false,
            easing: element.dataset.easing,
            gap: Number(element.dataset.gap),
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: 0 },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            },
            autoScroll: {
                speed
            }
        })
        mySplide.mount(window.splide.Extensions)
    })
}
initInstagramGallery()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.instagram-gallery')) {
        initInstagramGallery()
    }
})

/*
    TikTok Slider
*/
const initTikTokSlider = () => {
    document.querySelectorAll('.tiktok-slider').forEach(section => {
        const element = section.querySelector('.splide')

        const mySplide = new Splide(element, {
            arrows: element.dataset.arrows === 'true',
            pagination: false,
            easing: element.dataset.easing,
            perMove: Number(element.dataset.perMove),
            autoplay: element.dataset.autoplay === 'true',
            interval: Number(element.dataset.interval),
            per_move: Number(element.dataset.perMove),
            rewind: element.dataset.rewind === 'true',
            gap: Number(element.dataset.gap),
            mediaQuery: 'min',
            breakpoints: {
                0: { perPage: Number(element.dataset.breakpointXs), padding: '15%' },
                576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
                768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
                992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
                1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
                1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
            }
        })
        mySplide.mount()

        section.querySelectorAll('video').forEach(video => {
            const videoWrapper = video.closest('.video-wrapper')
            const soundBtn = videoWrapper.querySelector('[data-toggle-sound]')

            video.addEventListener('click', (e) => {
                section.querySelectorAll(`video:not([data-index="${video.dataset.index}"])`).forEach(video => {
                    video.pause()
                    video.closest('.video-wrapper').classList.remove('is-playing')
                })

                if (videoWrapper.classList.contains('is-playing')) {
                    video.pause()
                    videoWrapper.classList.remove('is-playing')
                } else {
                    video.play()
                    videoWrapper.classList.add('is-playing')

                    if (section.dataset.volume === 'on') {
                        video.muted = false
                        soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
                        soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
                    }
                }
            })

            soundBtn?.addEventListener('click', () => {
                video.muted = !video.muted

                if (video.muted) {
                    soundBtn.querySelector('.icon-volume-off').removeAttribute('hidden')
                    soundBtn.querySelector('.icon-volume-on').setAttribute('hidden', 'hidden')
                    section.setAttribute('data-volume', 'off')
                } else {
                    soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
                    soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
                    section.setAttribute('data-volume', 'on')
                }
            })
        })

        mySplide.on('moved', (newIndex, prevIndex) => {
            const video = section.querySelector(`video[data-index="${newIndex}"]`)
            const videoWrapper = video.closest('.video-wrapper')
            const soundBtn = videoWrapper.querySelector('[data-toggle-sound]')

            if (video) {
                section.querySelectorAll(`video:not([data-index="${newIndex}"])`).forEach(video => {
                    video.muted = true
                    video.pause()
                    video.closest('.video-wrapper').classList.remove('is-playing')
                })

                video.play()

                videoWrapper.classList.add('is-playing')

                if (section.dataset.volume === 'on' && !navigator.userAgent.match(/(iPad|iPhone)/g)) {
                    video.muted = false
                    soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
                    soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
                }
            }
        })
    })
}
initTikTokSlider()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.tiktok-slider')) {
        initTikTokSlider()
    }
})

/*
    Parallax image
*/
const initParallaxImage = () => {
    document.querySelectorAll('.parallax-image').forEach(section => {
        const imgMobile = section.querySelector('.img-mobile')
        const imgDesktop = section.querySelector('.img-desktop')

        // eslint-disable-next-line new-cap, no-new
        new simpleParallax(imgMobile, {
            orientation: imgMobile.dataset.orientation,
            scale: Number(imgMobile.dataset.scale / 100)
        })

        // eslint-disable-next-line new-cap, no-new
        new simpleParallax(imgDesktop, {
            orientation: imgDesktop.dataset.orientation,
            scale: Number(imgDesktop.dataset.scale / 100)
        })
    })
}
initParallaxImage()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.parallax-image')) {
        initParallaxImage()
    }
})

/*
    Sticky ATC
*/
const initStickyAtc = async () => {
    const wrapper = document.querySelector('#sticky-atc')

    if (!wrapper) return

    await new Promise(resolve => setTimeout(resolve, 1000))

    const threshold = document.querySelector('.product-content .form-wrapper').getBoundingClientRect().bottom + window.scrollY

    window.addEventListener('scroll', () => {
        if (window.scrollY > threshold) {
            wrapper.classList.add('show')
            document.body.style.paddingBottom = wrapper.clientHeight + 'px'
        } else {
            wrapper.classList.remove('show')
            document.body.style.paddingBottom = 0
        }
    })
}
initStickyAtc()

/*
    Newsletter Popup
*/
const initNewsletterPopup = async () => {
    const modal = document.querySelector('#newsletter-popup-modal')

    if (!modal) return

    const bsModal = bootstrap.Modal.getOrCreateInstance(modal)

    if (window.location.href.includes('newsletter-popup')) {
        bsModal.show()
        return
    }

    if (document.cookie.indexOf('ecomify-newsletter-popup') > -1) return

    await new Promise(resolve => setTimeout(resolve, Number(modal.dataset.delay) * 1000))

    window.createCookie('ecomify-newsletter-popup', true, Number(modal.dataset.daysToWait))

    bsModal.show()
}
initNewsletterPopup()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#newsletter-popup-modal')) {
        const bsModal = bootstrap.Modal.getOrCreateInstance('#newsletter-popup-modal')
        bsModal.show()
    }
})

/*
    Animated Stories
*/
const initAnimatedStories = () => {
    const localStorageKeyMain = 'ecomify_animated_stories'
    const localStorageKeyTime = 'ecomify_animated_stories_time'

    document.querySelectorAll('.animated-stories-link').forEach(link => {
        let storiesRead = JSON.parse(localStorage.getItem(localStorageKeyMain)) || []

        if (new Date().getTime() > Number(localStorage.getItem(localStorageKeyTime)) + 8.64e+7) {
            storiesRead = []
        }

        const storyIsRead = storiesRead.some((elem) => elem === link.getAttribute('href'))

        if (storyIsRead) {
            link.classList.add('story-is-read')
        }

        link.addEventListener('click', (e) => {
            if (!storyIsRead) {
                storiesRead.push(link.getAttribute('href'))
            }

            localStorage.setItem(localStorageKeyMain, JSON.stringify(storiesRead))
            localStorage.setItem(localStorageKeyTime, new Date().getTime())
        })
    })
}
initAnimatedStories()

/*
    Image Compare
*/
const initImageCompare = () => {
    document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
            document.querySelectorAll('.image-compare-slider').forEach(slider => {
                new ImageCompare(slider, {
                    controlColor: slider.dataset.controlColor,
                    controlShadow: true,
                    addCircle: slider.dataset.addCircle === 'true',
                    addCircleBlur: false,
                    showLabels: slider.dataset.showLabels === 'true',
                    labelOptions: {
                        before: slider.dataset.labelBefore,
                        after: slider.dataset.labelAfter,
                        onHover: slider.dataset.labelOnHover === 'true'
                    },
                    smoothing: slider.dataset.smoothing === 'true',
                    smoothingAmount: Number(slider.dataset.smoothingAmount),
                    hoverStart: slider.dataset.hoverStart === 'true',
                    verticalMode: slider.dataset.verticalMode === 'true',
                    startingPoint: Number(slider.dataset.startingPoint),
                    fluidMode: false
                }).mount()
            })
        }
    }
}
initImageCompare()

document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.image-compare-slider')) {
        initImageCompare()
    }
})
